import { Button, TextField, MenuItem, Card, CardContent, Typography, List, ListItem, ListItemText, CardActions, IconButton, ListItemSecondaryAction, Tooltip } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { useEffect, useState } from "react";
import { Edit2, Save, Send, Trash, X, XCircle } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { RootState } from "../../../../app/store";
import { setNotePointModal } from "../../../dashboard/dashboard.reducer";
import { completeMarker, createComment, deleteTempNoteMarker, editNoteMarker, getNoteChat, getNoteDeleteRequests, getNoteListByJobNumberId, getNoteListDeleted, postNoteMarker, rejectRequestDeleteNoteMarker, requestDeleteNoteMarker } from "../../sideTab.api";
import { clearChatList, setNoteList, setNoteListDeleted } from "../../sideTab.reducer";

export default function NotePointModal() {

  const dispatch = useDispatch()

  const { notePointModal, notePoint } = useSelector((state: RootState) => state.dashboard)
  const { jobNumberIdActive, noteList, noteListDeleted, noteEnums, chatList, requestDeleteList } = useSelector((state: RootState) => state.sideTab)

  const [form, setForm] = useState<any>({
    markerImportType: 0,
    markerType: 4,
    name: "",
    description: "",
    style: "",
    latitude: (notePoint?.lat)?.toString(),
    longitude: (notePoint?.lng)?.toString(),
    lineData: "",
    jobNumberId: jobNumberIdActive.id,
    markerColor: 0,
    userId: localStorage.getItem("id")
  })
  const [isView, setIsView] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [emails, setEmails] = useState<any>([])
  const [emailTemp, setEmailTemp] = useState("")
  const [chat, setChat] = useState("")

  useEffect(() => {
    if (notePointModal.data) {
      setIsView(true)
      setForm({
        ...form,
        name: notePointModal.data.name,
        description: notePointModal.data.description,
        markerColor: notePointModal.data.markerColor,
      })
      setEmails(notePointModal.data.recipientEmails)
      dispatch(getNoteChat(notePointModal?.data?.id))
      dispatch(getNoteDeleteRequests(notePointModal?.data?.id))
    }
    else {
      dispatch(clearChatList())
      setEmails([])
    }
  }, [notePointModal])

  const handleChangeForm = (e: any) => {
    let name = e.target.name
    let value = e.target.value
    setForm({
      ...form,
      [name]: value
    })
  }

  const handleCancel = () => {
    dispatch(setNotePointModal({ status: false }))
  }

  const handleSave = (e: any) => {
    if (isEdit) {
      let data = {
        id: notePointModal?.data?.id,
        description: form?.description,
        name: form?.name,
        markerColor: form?.markerColor,
        recipientEmails: emails
      }
      console.log(data)
      dispatch<any>(editNoteMarker(data))
        .unwrap()
        .then((res: any) => {
          if (res.status >= 400) {
            Swal.fire("Edit point note failed!", res?.data?.message);
          }
          else {
            handleCancel()
            dispatch(setNotePointModal({}))
            dispatch<any>(getNoteListByJobNumberId(jobNumberIdActive.id))
              .unwrap()
              .then((res: any) => {
                let noteListNew: any = noteList?.filter((item: any) => item.jobNumberId !== jobNumberIdActive.id)
                dispatch(setNoteList(noteListNew.concat(res.data)))
              })
          }
        })
    }
    else {
      dispatch<any>(postNoteMarker({
        ...form,
        recipientEmails: emails
      }))
        .unwrap()
        .then((res: any) => {
          if (res.status >= 400) {
            Swal.fire("Add point note failed!", res?.data?.message);
          }
          else {
            if (chat) {
              dispatch(createComment({
                markerId: res?.data?.id,
                comment: chat,
                userId: localStorage.getItem('id')
              }))
            }
            handleCancel()
            dispatch(setNotePointModal({}))
            dispatch<any>(getNoteListByJobNumberId(jobNumberIdActive.id))
              .unwrap()
              .then((res: any) => {
                let noteListNew: any = noteList?.filter((item: any) => item.jobNumberId !== jobNumberIdActive.id)
                dispatch(setNoteList(noteListNew.concat(res.data)))
              })
          }
        })
    }
  }

  const handleEdit = () => {
    setIsView(false)
    setIsEdit(true)
  }

  const handleDelete = () => {
    dispatch<any>(deleteTempNoteMarker(notePointModal?.data?.id))
      .unwrap()
      .then((res: any) => {
        dispatch<any>(getNoteListByJobNumberId(notePointModal?.data?.jobNumberId))
          .unwrap()
          .then((res: any) => {
            let noteListNew: any = noteList?.filter((item: any) => item.jobNumberId !== notePointModal?.data?.jobNumberId)
            dispatch(setNoteList(noteListNew.concat(res.data)))
            dispatch(setNotePointModal({ status: false }))
          })
        dispatch<any>(getNoteListDeleted(notePointModal?.data?.jobNumberId))
          .unwrap()
          .then((res: any) => {
            let noteListDeletedNew: any = noteListDeleted?.filter((item: any) => item.jobNumberId !== notePointModal?.data?.jobNumberId)
            dispatch(setNoteListDeleted(noteListDeletedNew.concat(res.data)))
          })
      })
  }

  const handleRequestDelete = () => {
    dispatch<any>(requestDeleteNoteMarker(notePointModal?.data?.id))
      .unwrap()
      .then((res: any) => {
        Swal.fire("Success", `Your delete action has been requested to ${notePointModal?.data?.creator}`)
      })
  }

  const handleRejectRequestDelete = (id: string) => {
    dispatch<any>(rejectRequestDeleteNoteMarker(id))
      .unwrap()
      .then((res: any) => {
        dispatch(getNoteDeleteRequests(notePointModal?.data?.id))
      })
  }

  const handleSubmitChat = () => {
    dispatch<any>(createComment({
      markerId: notePointModal?.data?.id,
      comment: chat,
      userId: localStorage.getItem('id')
    }))
      .unwrap()
      .then(() => {
        setChat("")
        dispatch(getNoteChat(notePointModal?.data?.id))
      })
  }

  const handleComplete = (id: string) => {
    dispatch<any>(completeMarker({ targetMarkerId: id, userId: localStorage.getItem('id') }))
      .unwrap()
      .then(() => {
        dispatch<any>(getNoteListByJobNumberId(jobNumberIdActive.id))
          .unwrap()
          .then((res: any) => {
            dispatch(setNoteList(res.data))
            dispatch(setNotePointModal({ status: false }))
            Swal.fire("Success", "Notes successfully completed", "success")
          })
      })
  }

  return (
    <div className="formnote">
      <h3>Point<X onClick={handleCancel} /></h3>
      <div className="creator">
        {isView && (
          <span>
            created by {notePointModal?.data?.creator} at {moment(new Date(notePointModal?.data?.createdDate)).format("MM-DD-yyyy hh:mm:ss")}
          </span>
        )}
      </div>
      <form>
        <TextField
          className="inp"
          variant="outlined"
          type="text"
          label="Subject"
          size="small"
          name="name"
          value={form.name}
          onChange={handleChangeForm}
          inputProps={{
            readOnly: isView
          }}
        />
        <TextField
          className="inp"
          variant="outlined"
          type="text"
          label="Note"
          size="small"
          multiline={true}
          name="description"
          value={form.description}
          onChange={handleChangeForm}
          inputProps={{
            readOnly: isView
          }}
        />
        <TextField
          id="select"
          className="inp"
          label="Color"
          variant="outlined"
          size="small"
          select
          name="markerColor"
          value={form.markerColor}
          onChange={handleChangeForm}
          inputProps={{
            readOnly: isView
          }}>
          {noteEnums?.markerColors?.map((item: any) => (
            <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
          ))}
        </TextField>
        <Autocomplete
          multiple
          options={[...emails, emailTemp]}
          id="disable-clearable"
          value={emails}
          onInputChange={(e: any) => setEmailTemp(e.target?.value || "")}
          onChange={(e, value) => setEmails(value)}
          className="inp"
          disableClearable
          disabled={isView}
          renderInput={(params) => <TextField {...params} label="To" size="small" placeholder="Search email" variant="outlined" />}
        />
        <br />
        <Card>
          <CardContent>
            <Typography variant="h6">
              Chats
            </Typography>
            <List>
              {chatList.map((chat: any) => (
                <ListItem>
                  <ListItemText
                    primary={chat.comment}
                    secondary={`> ${chat.userName} at ${chat.time}`}

                  />
                </ListItem>
              ))}
            </List>
          </CardContent>
          <CardActions>
            <TextField fullWidth variant="outlined" label="Message" value={chat} onChange={(e) => setChat(e.target.value)} />
            {(emails.includes(localStorage.getItem("email")) || localStorage.getItem("email") === notePointModal?.data?.creator) && (
              <IconButton onClick={handleSubmitChat}>
                <Send />
              </IconButton>
            )}
          </CardActions>
        </Card>
        {localStorage.getItem("email") === notePointModal?.data?.creator && (
          <>
            <br />
            <Card>
              <CardContent>
                <Typography variant="h6">
                  Delete Request
                </Typography>
                <List>
                  {requestDeleteList.map((request: any) => (
                    <ListItem>
                      <ListItemText
                        primary={request.requestedBy}
                        secondary={`> at ${request.dateRequest}`}
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="reject request">
                          <IconButton onClick={() => handleRejectRequestDelete(request.id)}>
                            <XCircle />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </>
        )}
        {(localStorage.getItem("email") === notePointModal?.data?.creator || !isView)
          ? (
            <>
              <br />
              <div className="wrapbutton" >
                <div className="left">
                  {notePointModal?.data?.status === 0 && (
                    <Button className="done" onClick={() => handleComplete(notePointModal?.data?.id)}>
                      Complete Note
                    </Button>
                  )}
                </div>
                {isView
                  ? (
                    <>
                      <Button className="delete" variant="outlined" onClick={handleDelete}>
                        <Trash /> Delete
                      </Button>
                      <Button className="edit" variant="outlined" onClick={handleEdit}>
                        <Edit2 /> Edit
                      </Button>
                    </>
                  )
                  : (
                    <Button className="save" variant="outlined" onClick={handleSave}>
                      <Save /> Save
                    </Button>
                  )
                }
              </div>
            </>
          )
          : (
            <>
              <br />
              <div className="wrapbutton" >
                <Button className="delete" variant="outlined" onClick={handleRequestDelete}>
                  <Trash /> Delete
                </Button>
              </div>
            </>
          )}
      </form>
    </div>
  );
}
